module.exports = __webpack_public_path__ + "img/zstp.9259ed5a.png";